import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BarChartData } from 'Molecules/InsightsChart/chartBuilder';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseProjectsCategoryPayload } from '../payloads/projectsCategoryPayload';
import { InsightChartFactory } from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';
import { groupDataByCategory } from '../utils/dataGrouping';
import { getProjectStatusGroupLegendName } from '../utils/legendLocalizationHelper';
import intl from 'react-intl-universal';

export const buildProjectsCategoryInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseProjectsCategoryPayload(payload);
  const rawData = parsedPayload.data.attributes.data;

  return (props) => {
    // Use the generic data grouping utility
    const { transformedData, uniqueCategories } = groupDataByCategory({
      rawData,
      groupKey: 'category_id',
      displayField: 'category_name',
      categoryField: 'project_status_group',
      valueField: 'project_count',
    });

    // Create field names, legend names, and stacks
    const xAxisFieldNames = uniqueCategories;
    const legendNames = uniqueCategories.map(getProjectStatusGroupLegendName);
    const stacks = new Array(uniqueCategories.length).fill('projects');

    const chart = new ChartBuilder()
      .setChartType(ChartType.H_BAR_STACK)
      .setProps({
        chartData: transformedData as BarChartData,
        onDrillDown: props.onDrillDown,
        yAxisFieldName: 'category_name',
        xAxisFieldNames,
        legendNames,
        stacks,
        barAxisName: intl.get('INSIGHT.AXIS.NUMBER_OF_PROJECTS'),
        yAxisName: intl.get('INSIGHT.AXIS.CATEGORIES'),
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
    });
  };
};
